import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import _get from 'lodash/get';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts';
import IconPattern from '@mlb/react-patterns/components/Icon/icon';

const Container = styled.p`
    margin: 10px 0 0;
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 15px;
`;

const Icon = styled(IconPattern)`
    stroke: none;
`;

const Text = styled.span`
    vertical-align: top;
    margin-left: 5px;
    a {
        color: ${COLORS.mlbWhite};
        font-weight: bold;
        vertical-align: top;
        &:hover {
            color: ${COLORS.mlbWhite};
        }
    }
`;

const UserCreated = ({
    dictionary,
    userInfo,
    onLinkClick,
}) => {

    const onLinkClickHandler = (e) => {

        onLinkClick();

    };

    const {
        nickName,
        firstName,
        userId,
    } = userInfo;

    const url = `/${userId}/reels`;
    const displayName = nickName || firstName || userId;

    const displayText = displayName
        ? (
            <>
                {_get(dictionary, 'created_by', 'Created By') + ' '}
                <Link
                    aria-label={`${_get(dictionary, 'view_all_reels_by', 'View all reels by')} ${displayName}`}
                    to={url}
                    onClick={onLinkClickHandler}
                >
                    {displayName}
                </Link>
            </>
        )
        : _get(dictionary, 'fan_created_on_film_room', 'Fan-Created on MLB Film Room');

    return (
        <Container>
            <Icon name={'reels'} width={22} fill={COLORS.mlbWhite} />
            <Text>{displayText}</Text>
        </Container>
    );

};

UserCreated.propTypes = {
    dictionary: PropTypes.object.isRequired,
    userInfo: PropTypes.object.isRequired,
    onLinkClick: PropTypes.func.isRequired,
};

export default UserCreated;
